<template>
    <div>
        teaser
    </div>
</template>

<script>
    export default {
        created: function() {
        },
        methods: {
        },
    }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// Teaser.vue?bc28cea2